
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class SectionH1 extends Vue {}
